import { useCallback } from "react";
import { isString } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { modalIsOpen } from "@linkfluence/core/modal/selectors";
import { Action } from "./actions";

interface State {
  __modal: Record<string, boolean>;
}

function useOpenModal(modalId: string) {
  const dispatch = useDispatch();
  return useCallback(
    (_modalId?: string) =>
      dispatch(Action.open(isString(_modalId) ? _modalId : modalId)),
    [dispatch, modalId]
  );
}

function useCloseModal(modalId: string) {
  const dispatch = useDispatch();
  return useCallback(
    (_modalId?: string) =>
      dispatch(Action.close(isString(_modalId) ? _modalId : modalId)),
    [dispatch, modalId]
  );
}

function useIsModalOpen(modalId: string) {
  return useSelector((state: State) => modalIsOpen(state, modalId));
}

function useModal(modalId: string, isOpen?: boolean) {
  const isModalOpen = useIsModalOpen(modalId);
  return {
    isOpen: isOpen || isModalOpen,
    open: useOpenModal(modalId),
    close: useCloseModal(modalId),
    ModalWrapper: useCallback(
      ({ children }) => (isModalOpen ? children : null),
      [isModalOpen]
    ),
  };
}

export const Modal = {
  get: useModal,
  open: useOpenModal,
  close: useCloseModal,
  isOpen: useIsModalOpen,
};
